module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"monitoredStructure":"Structure"},"it":{"monitoredStructure":"Struttura"}}')
  delete Component.options._Ctor
}
